import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { INFOGRAPHIC_CONVERTER_TOKEN, InfographicComponentConverter } from './infographic.component.converter'
import {
  INFOGRAPHIC_SLIDE_CONVERTER_TOKEN, InfographicSlideConverter
} from './infographic-slide/infographic-slide/infographic-slide.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        infographicFeature: {
          module: () => import('./infographic.module').then((m) => m.InfographicModule),
          cmsComponents: ['infographic'],
        },
      }
    }),
    {
      provide: INFOGRAPHIC_CONVERTER_TOKEN,
      useClass: InfographicComponentConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        infographic: INFOGRAPHIC_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: INFOGRAPHIC_SLIDE_CONVERTER_TOKEN,
      useClass: InfographicSlideConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        infographic_slide: INFOGRAPHIC_SLIDE_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class InfographicFeatureModule {
}
